import { navigationDrawerStyles } from "@insite/content-library/Components/NavigationDrawer";
import { css } from "styled-components";

navigationDrawerStyles.userRowTypography = {
    transform: "uppercase",
    color: "common.background",
    css: css`
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 200px;
    `,
};
navigationDrawerStyles.menuTriggerButton = {
    shape: "pill",
    color: "primary",
    size: 50,
};
